import { MEMBERS_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import { getApplicationConfig } from './communities-context-selectors';

export const getIsMemberAppInstalled = state => Boolean(getApplicationConfig(state, MEMBERS_APP_ID).isInstalled);
